<script>
  export let content
</script>

<div aria-live="assertive" class="error-banner">
 { content }
</div>

<style>
  .error-banner {
    background-color: var(--clr-error-background);
    border: 1px solid currentColor;
    border-radius: 0.25rem;
    color: var(--clr-error-text);
    margin: 1rem auto;
    max-width: 60ch;
    padding: 2vmin;
  }
</style>